import { FaWifi, FaRedo } from "react-icons/fa";
import { Button } from "components/common";
import { Card } from "components/common/cards";
import { CUSTOMER_SUCCESS_EMAIL, CUSTOMER_SUCCESS_MAILTO } from "config/constant";

interface NetworkErrorProps {
  onRetry?: () => void;
  title?: string;
  description?: string;
  showRetry?: boolean;
}

export const NetworkError = ({
  onRetry,
  title = "Connection Error",
  description = "Unable to connect to our servers. Please check your internet connection and try again.",
  showRetry = true,
}: NetworkErrorProps) => {
  return (
    <Card className="p-6 text-center">
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 rounded-full bg-danger/10 flex items-center justify-center">
          <FaWifi className="text-2xl text-danger" />
        </div>
      </div>

      <h3 className="text-xl font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-muted-foreground mb-6">{description}</p>

      {showRetry && onRetry && (
        <Button onClick={onRetry} className="w-full">
          <FaRedo className="mr-2" />
          Try Again
        </Button>
      )}

      <div className="mt-4 text-sm text-muted-foreground/70">
        <p>
          If this problem persists, please contact{" "}
          <a href={CUSTOMER_SUCCESS_MAILTO} className="underline hover:text-muted-foreground">
            {CUSTOMER_SUCCESS_EMAIL}
          </a>
          .
        </p>
      </div>
    </Card>
  );
};
